module.exports = __webpack_public_path__ + "img/snoopy2x.cbc86c60.png";